// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"nK1ngf3WdXdFMXlgd4MK","spaced":"jNwae3LkjeuJdIoQBY_l","description":"MLWeYIf8VoI9NF7X9H6c"};